
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M18 3.071a15.328 15.328 0 00-10.91 4.52A15.328 15.328 0 002.571 18.5c0 4.121 1.605 7.996 4.52 10.91A15.327 15.327 0 0018 33.929c4.121 0 7.996-1.605 10.91-4.52A15.327 15.327 0 0033.429 18.5c0-4.121-1.605-7.996-4.52-10.91A15.327 15.327 0 0018 3.071zM18 .5c9.941 0 18 8.059 18 18s-8.059 18-18 18-18-8.059-18-18S8.059.5 18 .5z","fill":"#000"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M6.737 28.882s6.218-4.333 11.347-4.333c5.128 0 12.249 4.333 12.249 4.333a14.765 14.765 0 01-12.25 6.11 13.923 13.923 0 01-11.346-6.11z","stroke":"#000","stroke-width":"2"}}),_c('path',{attrs:{"d":"M23.143 14.643a5.143 5.143 0 10-10.286 0 5.143 5.143 0 0010.286 0z","stroke":"#000","stroke-width":"2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#000","transform":"translate(0 .5)","d":"M0 0h36v36H0z"}})])])])
          )
        }
      }
    